var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { cls_overlay, cls_content, cls_title, cls_description, cls_dialog_content, } from "./dialog.css";
export var StyledOverlay = React.forwardRef(function (props, forwardRef) {
    return React.createElement(DialogPrimitive.Overlay, __assign({ ref: forwardRef }, props, { className: cls_overlay }));
});
function Content(props) {
    return (React.createElement(DialogPrimitive.Portal, null,
        React.createElement(StyledOverlay, null),
        React.createElement(DialogPrimitive.Content, __assign({}, props, { className: "".concat(cls_content, " ").concat(cls_dialog_content) }), props.children)));
}
export var StyledTitle = function (props) {
    return React.createElement(DialogPrimitive.Title, __assign({}, props, { className: cls_title }));
};
export var StyledDescription = function (props) {
    return React.createElement(DialogPrimitive.Description, __assign({}, props, { className: cls_description }));
};
export var Dialog = DialogPrimitive.Root;
export var DialogTrigger = DialogPrimitive.Trigger;
export var DialogContent = Content;
export var DialogTitle = StyledTitle;
export var DialogDescription = StyledDescription;
export var DialogClose = DialogPrimitive.Close;
